import React from 'react';
import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';

import { Form } from 'libs/forms/index';

import {
  SettingsSectionWrapper,
  SettingsSection,
} from 'legacyComponents/styled/lib';
import Spinner from 'components/Spinner';
import { EmailPreferencesAppManager } from 'apps/profile/settings/tabs/notifications/emailPreferences/appManager';

@withNamespaces()
@observer
export class EmailPreferences extends React.Component {
  constructor(props) {
    super(props);
    this.appManager = new EmailPreferencesAppManager(null, {});
  }

  render() {
    const { loading, form, Submit } = this.appManager;
    if (loading) {
      return (
        <SettingsSection>
          <Spinner margin='30px auto' />
        </SettingsSection>
      );
    }
    return (
      <SettingsSectionWrapper>
        <SettingsSection>
          <Form
            formStore={form}
            buttonHandler={Submit}
            formTitleCentered={false}
            noBorder={true}
            responsive
            padding='0px 0px 20px 0px'
          />
        </SettingsSection>
      </SettingsSectionWrapper>
    );
  }
}
